import {H3, H2, PNoMargin} from '@/typography';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Row, Col} from '@/grid';
import {withMarginBottomDoubleXlToXl} from '@/hocs/withSpacing';
import {withBgNeutral200} from '@/hocs/withColors';
import {withUppercase} from '@/hocs/withFontType';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import PictureWrapper from '@/ui/images-wrapper';
import {withTextLeftToCenter} from '@/hocs/withAlignment';
import {useTranslations} from 'next-intl';
import {DivMargined, FeatureItem, Grid} from '@/content/features/shared';

const imgPath = '/static/images/features/information-system/';

const Neutral200Section = withBgNeutral200(SectionPadding);
const RowMargined = withMarginBottomDoubleXlToXl(Row);
const H3Upper = withTextLeftToCenter(withUppercase(withMarginBottomDoubleXlToXl(H3)));

const InformationSystemSection = () => {
  const t = useTranslations('features.informationSystem');

  const OnboardingFeaturesArray = t.raw('onboarding.features') as FeatureItem[];
  const EmployeeManagementFeaturesArray = t.raw('employeeManagement.features') as FeatureItem[];

  return (
    <Neutral200Section>
      <Container>
        <Grid fluid>
          <RowMargined center="xs" start="lg" middle="xs">
            <Col xs={12} lg={4}>
              <H2>{t('title')}</H2>
            </Col>
            <Col xs={12} lg={8}>
              <PictureWrapper
                imgPath={imgPath}
                imageUrl="hr-information-system"
                imageTypeFallback="jpg"
                altImage={t('imageAlt')}
              />
            </Col>
          </RowMargined>

          <DivMargined>
            <H3Upper className="heading-4">{t('onboarding.title')}</H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {OnboardingFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--neutral400)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">
              {t('employeeManagement.title')}
            </H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {EmployeeManagementFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--neutral400)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>
        </Grid>
      </Container>
    </Neutral200Section>
  );
};

export default InformationSystemSection;
